import React, { useContext, useState, useEffect } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import { AuthContext } from '../../../contexts/AuthContext';
import { apiRoutes } from '../../../AppSettings';
import axios from 'axios';
import SideNav from '../../doctor/shared/SideNav';
import Util from '../../../Util';
import { Link } from 'react-router-dom';

const Invoice = () => {
    const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer '+ userState.token
            }
          };

          axios.get(apiRoutes.getinvoices + doctor.doctorId, options)
          .then((response) => {
            if(response.status === 200)
            {

                const data = response.data;
                console.log(data.data);

                setInvoices(data.data);
              //  console.log(data.data)
            }
          }, (error) => {
            console.log(error);
          });
    }, []);

    return (
        <div>
            <Breadcrumb title="Invoices" />
            <div className="content">
				<div className="container-fluid">

					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor = 'invoices' user={doctor}/>
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="card card-table">
								<div className="card-body">
									<div className="table-responsive">
										<table className="table table-hover table-center mb-0">
											<thead>
												<tr>
													<th>Invoice No</th>
													<th>Patient</th>
													<th>Amount</th>
													<th>Paid On</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
                                                {
                                                    invoices.map(invoiceData => (
                                                        <tr key={invoiceData.invoice.invoiceId}>
                                                            <td>
                                                                <Link to={
                                                                    {
                                                                        pathname:'/invoiceview',
                                                                        state: {
                                                                            invoiceId: invoiceData.invoice.invoiceId
                                                                        }
                                                                    }
                                                                }>{invoiceData.invoice.invoiceNumber}</Link>
                                                            </td>
                                                            <td>
                                                                <h2 className="table-avatar">
                                                                        <Link  className="avatar avatar-sm mr-2" to={
                                                                            {
                                                                                pathname:'/PatientProfile',
                                                                                state: {
                                                                                    patientId: invoiceData.patient.patientId
                                                                                }
                                                                            }
                                                                        }>
                                                                        <img className="avatar-img rounded-circle" src={Util.loadImage(invoiceData.patient.profileImage)} alt="User Image" />
                                                                     </Link>
                                                                     <Link  to={
                                                                            {
                                                                                pathname:'/PatientProfile',
                                                                                state: {
                                                                                    patientId: invoiceData.patient.patientId
                                                                                }
                                                                            }
                                                                        }>
                                                                      
                                                                        {invoiceData.patient.firstName} {invoiceData.patient.lastName} <span>{invoiceData.patient.patientNumber}</span> </Link>
                                                                </h2>
                                                            </td>
                                                            <td>${ invoiceData.invoice.totalAmount }</td>
                                                            <td>{ Util.getFormatDate({ date: invoiceData.invoice.createdDate }) }</td>
                                                            <td className="text-right">
                                                                <div className="table-action">
                                                                    <Link className="btn btn-sm bg-info-light" to={
                                                                        {
                                                                            pathname:'/invoiceview',
                                                                            state: {
                                                                                invoiceId: invoiceData.invoice.invoiceId
                                                                            }
                                                                        }
                                                                    }>View</Link>
                                                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light">
                                                                        <i className="fas fa-print"></i> Print
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
											</tbody>
										</table>
									</div>
									
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>		
			
        </div>
    );
}
 
export default Invoice;